import { HttpClient } from '@angular/common/http';
import { of, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class WikiService {
    constructor(http) {
        this.http = http;
        this.wikiCache = new Map();
    }
    getWikiText(name, fromCache = true) {
        if (fromCache && this.wikiCache.has(name)) { // read from cache
            const description = this.wikiCache.get(name);
            return of(description);
        }
        else { // live request      
            return this.http.get(`/search/wiki?name=${name}`)
                .pipe(
            // get description
            map((response) => response.description), 
            // special case: catch + cache 404
            catchError((err) => err.status === 404 ? of('') : throwError(err)), 
            // add cache entry
            tap((description) => this.wikiCache.set(name, description)));
        }
    }
}
WikiService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WikiService_Factory() { return new WikiService(i0.ɵɵinject(i1.HttpClient)); }, token: WikiService, providedIn: "root" });
